import styled from 'styled-components';
import {Form, Input, Button} from 'global/styles/styles.js';
const S = {};

S.ForgotPasswordForm = styled(Form)`
width: 100%;
`;

S.Row = styled.div``;

S.Label = styled.label`
    pointer-events: none;
    transition: .2s;
    position: absolute;
    top: 1.4rem;
    left: 1.8rem;
    color: #787d83!important;
    font-size: 1.33rem;
    font-weight: 400;
    line-height: 10px
`;

S.InputWrapper = styled.div`
    position: relative;
    margin: 0 25px;
`;

S.Input = styled(Input)`
    box-shadow: none;
    border-radius: 1.3125rem;
    border: .08rem solid #e1e1e1;
    color: ${({error})=> (error!=null) ? '#CA2717' : '#000' };
    font-size: 1.33rem;
    padding: 0 19px;
    background-color: #f6f6f6;
    display: block;
    width: 100%;
    height: 43px;
    &:valid{
        & + ${S.Label}{
        margin-top: -1.42rem;
        font-size: 1.08rem;
        }
    }
`;

S.SubmitBtn = styled(Button)`
    width: 388px;
    height: 2.6875rem;
    color: #fff;
    background-color: #019A44;
    font-size: 16px;
    font-weight: 800;
    text-align: center;
    line-height: 10px;
    padding: 0;
    margin: 23px 25px;
    border-radius: 21px;
    display: block;
    cursor: pointer;
`;

S.Error = styled.div`
    color: red;
    margin: 5px 0;
`;

S.SubmissionError = styled.div`
    margin: 10px 44px 10px;
    border-radius: .25rem;
    width: 100%;
    color: red;
    font-size: 1rem;
    text-align: left;
`;

S.Info = styled.p`
    margin: 27px 44px 13px;
    color: #000;
    font-weight: 800;
    font-size: 13px;
`;

S.SuccessModal = styled.div`
`;

S.SuccessModalTitle = styled.h4`
    color: #2d9ef5;
    text-transform: uppercase;
    font-size: 1.83rem;
    padding: 0;
    font-weight: 800;
    font-style: italic;
    float: none!important;
    text-align: center;
    margin-bottom: 3.42rem;
`;

S.SuccessModalMessage = styled.p`
    text-align: center;
    color: #000;
    margin: 0;
    font-size: 1.1538461538rem;
    letter-spacing: .2px;
    font-weight: 400;
`;

S.LoginLink = styled.span`
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.33rem;
    color: #0047B9;
    border: none;
    padding: 0;
    width: 100%;
    margin: 0 0 0 0.2222rem;
    text-decoration:underline #0047B9;
    cursor: pointer;
`;

S.CreateAccountContainer = styled.div`
    margin: 0 44px 41px;

span{
    font-size:1rem;
    font-weight:600;
}
`

S.ErrorModal = styled.div``;

export default S;
